
import Vue from "vue";
import $ from "jquery";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action, State, Getter } from "vuex-class";

import PaginationMiniComponent from "@/components/paginations/PaginationMini.vue";
import { Watch } from "vue-property-decorator";

@Component({
  components: {
    PaginationMiniComponent,
  },
  filters,
})
export default class JobFairCompanyList extends Vue {
  /* VUEX */

  // ACTION
  @Action("actionJobFairCompanyList", { namespace: "job" })
  private actionJobFairCompanyList: any;
  @Action("actionPaginationJobFairCompanyList", { namespace: "job" })
  private actionPaginationJobFairCompanyList: any;

  // STATE
  @State("job_fair", { namespace: "job" })
  private job_fair: any;
  @State("job_fair_company_list", { namespace: "job" })
  private job_fair_company_list: any;

  /* INITIALIZATION */
  private onLoad: boolean = false;
  private activePage: number = 1;


  public get companyList() : any[] {
    if(this.job_fair.id) return this.job_fair_company_list.results
    return []
  }

  @Watch("$router") OnChangesRoute(){
    this.job_fair_company_list = new JobFairCompanyList
  }


  private created() {
    // RESIZE RESPONSIVE CARD
    this.resizeTab();

    setTimeout(() => {
      this.listenInfinityScroll();
    }, 1000);
  }

  private mounted() {
    this.resizeTab();
  }

  /* METHOD */

  private listenInfinityScroll() {
    const self = this;
    $(document).ready(function() {
      // INFINITE SCROLL PAGINATION
      const tableJobfairCompany = $("#TableJobFairCompanyList");
      if (tableJobfairCompany.length > 0) {
        // Only Debug/Development
        // console.log("listened infinity scrol
        $("#TableJobFairCompanyList").scroll(function() {
          const scrollTop: number = $(this).scrollTop() ?? 0;
          // Only Debug/Development
          // console.log("Scroll Top : ", scrollTop);

          const innerHeight: number = $(this).innerHeight() ?? 0;
          // Only Debug/Development
          // console.log("Inner Height : ", innerHeight);

          const scrollHeight: number = $(this)[0].scrollHeight;

          // Only Debug/Development
          // const topAndInner = scrollTop + innerHeight;
          // console.log("Top & Inner : ", topAndInner);

          // Only Debug/Development
          // console.log("Scroll Height : ", scrollHeight);

          if (scrollTop + innerHeight >= scrollHeight) {
            if (!self.onLoad) {
              if (self.job_fair_company_list.results.length === 0) {
                return;
              }
              if (self.onLoad) {
                return;
              }
              if (self.job_fair_company_list.next) {
                self.activePage++;
                self.clickPage(self.activePage, self.job_fair_company_list.next);
              }
            }
          }
        });
      }
    });
  }

  private clickPage(page: number, url: string) {
    if (url) {
      this.actionPaginationJobFairCompanyList({
        params: {
          page,
          url,
          params: null,
        },
        success: (response: any) => {
          // TODO
        },
        fail: (response: any) => {
          // TODO
        },
      });
    } else {
      this.actionJobFairCompanyList({
        params: null,
        success: (responseCompanyList: any) => {
          // TODO
        },
        fail: (responseCompanyList: any) => {
          // TODO
        },
      });
    }
  }

  private clickCompany(company: any) {
    this.$router.push({
      name: "jobsFairCompany",
      params: { id: this.job_fair.id, company_id: company.id },
    });
  }

  private resizeTab() {
    const width = ($(document).width() as number) - ($('#cardProfile').width() as number) - 150;
    $('.tab-content').css('max-width', `${width}px`)
    $(window).on('resize', () => {
      const width = ($(document).width() as number) - ($('#cardProfile').width() as number) - 150;
      $('.tab-content').css('max-width', `${width}px`)
    })
  }
}
